var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 66,
    rx: 18,
    fill: "#2DAE32"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.9999 25.9101C39.0832 24.984 37.9911 24.2497 36.7876 23.7501C35.5841 23.2505 34.2931 22.9955 32.99 23.0001C27.53 23.0001 23.08 27.45 23.08 32.91C23.08 34.66 23.54 36.36 24.4 37.86L23 43L28.25 41.62C29.7 42.41 31.33 42.83 32.99 42.83C38.45 42.83 42.8999 38.38 42.8999 32.92C42.8999 30.27 41.8699 27.78 39.9999 25.9101ZM32.99 41.15C31.51 41.15 30.06 40.75 28.79 40L28.49 39.82L25.37 40.64L26.2 37.6L26 37.29C25.1777 35.977 24.7411 34.4593 24.74 32.91C24.74 28.37 28.44 24.6701 32.98 24.6701C35.18 24.6701 37.25 25.5301 38.8 27.09C39.5674 27.854 40.1756 28.7627 40.5893 29.7635C41.003 30.7642 41.214 31.8371 41.2099 32.92C41.2299 37.46 37.53 41.15 32.99 41.15ZM37.51 34.99C37.26 34.87 36.04 34.27 35.82 34.18C35.59 34.1 35.43 34.06 35.26 34.3C35.09 34.55 34.62 35.11 34.48 35.27C34.34 35.44 34.19 35.46 33.94 35.33C33.69 35.21 32.89 34.94 31.95 34.1C31.21 33.44 30.72 32.63 30.57 32.38C30.43 32.13 30.55 32 30.68 31.87C30.79 31.76 30.93 31.58 31.05 31.44C31.17 31.3 31.22 31.19 31.3 31.03C31.38 30.86 31.34 30.72 31.28 30.6C31.22 30.48 30.72 29.26 30.52 28.76C30.32 28.28 30.11 28.34 29.96 28.33H29.48C29.31 28.33 29.05 28.39 28.82 28.64C28.6 28.89 27.96 29.49 27.96 30.71C27.96 31.93 28.85 33.11 28.97 33.27C29.09 33.44 30.72 35.94 33.2 37.01C33.79 37.27 34.25 37.42 34.61 37.53C35.2 37.72 35.74 37.69 36.17 37.63C36.65 37.56 37.64 37.03 37.84 36.45C38.05 35.87 38.05 35.38 37.98 35.27C37.91 35.16 37.76 35.11 37.51 34.99Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.002eba222e9559e02013964b995ed2aa.svg";
export { ForwardRef as ReactComponent };